import controller from './state-change-modal';
import template from './state-change-modal.pug';

class StateChangeService {
  /* @ngInject */
  constructor($uibModal, $http) {
    this.$uibModal = $uibModal;
    this.$http = $http;
  }

  open(caseData, state) {
    return this
      .$uibModal
      .open({
        size: 'md',
        animation: true,
        template,
        controller,
        controllerAs: '$ctrl',
        resolve: {
          data: () => ({ case: caseData, state }),
          reasons: () => this.$http.get('/reason', {
            params: { stateId: state.state_id },
          })
            .then(({ data }) => data || []),
        },
      })
      .result;
  }
}

export default StateChangeService;



// WEBPACK FOOTER //
// ./client/components/state-change-modal/state-change-modal.service.js